/**
 * Created by alvinoktavianus on 5/9/17.
 */

import React, { Component } from 'react'
import styles from './Header.css'

class Header extends Component {
  render () {
    return (
      <div className={styles['wrapper']}>{this.props.title}</div>
    )
  }
}

Header.propTypes = {
  title: React.PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/Header/Header.js